//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    props: {
        tim_session_id: [Number, String],
        show_picker: Boolean,
        show_expression: Boolean,
        is_consultant_user: Boolean,
        target_is_consultant: Boolean,
        invite_disable: Boolean,
        show_invite: Boolean,
        show_building_report: Boolean
    }
}
